// extracted by mini-css-extract-plugin
export default {"swiperbtn":"SwipeBtn_swiperbtn__ktFGt","registerText":"SwipeBtn_registerText__PkINr","loginText":"SwipeBtn_loginText__JdxIt","activeClassName":"SwipeBtn_activeClassName__e0V7b"};